import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { UserDetailSectionId, USER_DETAIL_NAV_ITEMS, ZERDE_PRIMARY } from './types';

interface UserDetailNavProps {
  activeSection: UserDetailSectionId;
  onSectionClick: (sectionId: UserDetailSectionId) => void;
  /** Секции, которые карточка рендерит при правах оператора */
  visibleSections: UserDetailSectionId[];
}

export const UserDetailNav: React.FC<UserDetailNavProps> = ({
  activeSection,
  onSectionClick,
  visibleSections
}) => {
  const visibleItems = USER_DETAIL_NAV_ITEMS.filter(item => visibleSections.indexOf(item.id) !== -1);

  const currentTabIndex = visibleItems.findIndex(item => item.id === activeSection);
  const tabValue = currentTabIndex !== -1 ? currentTabIndex : 0;

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        px: { xs: 2, sm: 3.5 },
        bgcolor: '#ffffff',
        borderBottom: '1px solid #e2e8f0',
        boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
      }}
    >
      <Tabs
        value={tabValue}
        onChange={(_, index) => {
          const targetItem = visibleItems[index];
          if (targetItem) {
            onSectionClick(targetItem.id);
          }
        }}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          minHeight: 46,
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.86rem',
            minHeight: 46,
            py: 1,
            px: 2,
            color: '#64748b',
            '&.Mui-selected': {
              color: ZERDE_PRIMARY,
              fontWeight: 700
            }
          },
          '& .MuiTabs-indicator': {
            bgcolor: ZERDE_PRIMARY,
            height: 3,
            borderRadius: '3px 3px 0 0'
          }
        }}
      >
        {visibleItems.map(item => (
          <Tab
            key={item.id}
            label={item.label}
            sx={item.id === 'danger' ? { color: '#e11d48 !important' } : undefined}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default UserDetailNav;
